<div class="border border-shs-gray-3 rounded-md p-6 flex flex-col gap-6">
    <div class="flex items-center gap-4">
        <span class="animate-pulse h-6 w-36 bg-[#333333] rounded-md"></span>
    </div>
    <div class="flex flex-col">
        <span class="text-sm text-font-secondary">Nature of Complaint</span>
        <span class="animate-pulse h-7 w-20 bg-[#333333] rounded-md"></span>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Purchase Order Number</span>
            <span class="animate-pulse h-6 w-32 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Country</span>
            <span class="animate-pulse h-6 w-10 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Financial Adjustment</span>
            <span class="animate-pulse h-6 w-28 bg-[#333333] rounded-md"></span>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Created by</span>
            <span class="animate-pulse h-6 w-56 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Created on</span>
            <span class="animate-pulse h-6 w-20 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Order Date</span>
            <span class="animate-pulse h-6 w-20 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">TU</span>
            <span class="animate-pulse h-6 w-20 bg-[#333333] rounded-md"></span>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Sales Order Number</span>
            <span class="animate-pulse h-6 w-32 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Purchase Order Number</span>
            <span class="animate-pulse h-6 w-40 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Invoice Number</span>
            <span class="animate-pulse h-6 w-28 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Sales Organization</span>
            <span class="animate-pulse h-6 w-32 bg-[#333333] rounded-md"></span>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Ship To Customer Number</span>
            <span class="animate-pulse h-6 w-36 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Ship To Customer Name</span>
            <span class="animate-pulse h-6 w-40 bg-[#333333] rounded-md"></span>
        </div>
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Ship To State</span>
            <span class="animate-pulse h-6 w-40 bg-[#333333] rounded-md"></span>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Route</span>
            <span class="animate-pulse h-6 w-24 bg-[#333333] rounded-md"></span>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Affected Items</span>
            <div class="w-full overflow-x-auto">
                <div class="min-w-[1080px]">
                    <div
                        class="grid grid-cols-[70px_95px_115px_80px_minmax(160px,1fr)_85px_80px_95px_85px_80px_85px] gap-1 border-b border-shs-gray-4 mt-2"
                    >
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Line Item</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">SMN</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Delivery Number</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Batch</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Description</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Handling Unit</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Price/Item</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Source Plant</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Source Country</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Sales Order Qty</div>
                        <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Affected Qty</div>
                    </div>
                    <div class="animate-pulse h-8 w-full bg-[#333333] my-2 rounded-md"></div>
                    <div class="animate-pulse h-8 w-full bg-[#333333] my-2 rounded-md"></div>
                    <div class="animate-pulse h-8 w-full bg-[#333333] my-2 rounded-md"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex gap-10">
        <div class="flex flex-col">
            <span class="text-sm text-font-secondary">Assigned to</span>
            <span class="animate-pulse h-6 w-56 bg-[#333333] rounded-md"></span>
        </div>
    </div>
</div>
